'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import articleTypeValidator from '@haaretz/s-validators/articleTypeValidator';
import React from 'react';
const ArticleTypeContext = /*#__PURE__*/ React.createContext(undefined);
const ArticleTypeSetter = /*#__PURE__*/ React.createContext(undefined);
export function ArticleTypeProvider({ children, value: defaultArticleType }) {
    const [articleType, setArticleType] = React.useState(defaultArticleType);
    const articleTypeSetter = React.useCallback((value)=>{
        if (typeof value !== 'string' || value.trim() === '') {
            setArticleType('StandardArticle');
        } else {
            setArticleType(articleTypeValidator(value) ? value : 'StandardArticle');
        }
    }, []);
    return /*#__PURE__*/ _jsx(ArticleTypeContext, {
        value: articleType,
        children: /*#__PURE__*/ _jsx(ArticleTypeSetter, {
            value: articleTypeSetter,
            children: children
        })
    });
}
export default function useArticleType() {
    const context = React.use(ArticleTypeContext);
    if (context === undefined) {
        throw new Error('useArticleType must be used within a ArticleTypeProvider');
    }
    return context;
}
export function useSetArticleType() {
    const context = React.use(ArticleTypeSetter);
    if (context === undefined) {
        throw new Error('useSetArticleType must be used within a ArticleTypeProvider');
    }
    return context;
}
export function useArticleTypeAtom() {
    return [
        useArticleType(),
        useSetArticleType()
    ];
}

//# sourceMappingURL=articleTypeAtom.js.map